import script from "./dfl.vue?vue&type=script&setup=true&lang=js"
export * from "./dfl.vue?vue&type=script&setup=true&lang=js"

import "./dfl.vue?vue&type=style&index=0&id=6df604d8&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df604d8"]])

export default __exports__